import { render, staticRenderFns } from "./MiniCard.vue?vue&type=template&id=36ad030a&"
import script from "./MiniCard.vue?vue&type=script&lang=js&"
export * from "./MiniCard.vue?vue&type=script&lang=js&"
import style0 from "./MiniCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports